import React from 'react';
import SafeIcon from '../common/SafeIcon';

const REVIEWS = [
  { id: 1, name: 'Kwesi Mensah', dept: 'Operations', score: '4.8/5.0', date: 'Oct 2023', status: 'Completed' },
  { id: 2, name: 'Ama Appiah', dept: 'HR', score: '4.5/5.0', date: 'Oct 2023', status: 'Completed' },
  { id: 3, name: 'Samuel Boateng', dept: 'Logistics', score: '-', date: 'Nov 2023', status: 'Pending Review' },
];

const Performance = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Performance Management</h1>
          <p className="text-gray-500 text-sm">Track employee goals, appraisals, and feedback.</p>
        </div>
        <button className="bg-[#11469A] text-white px-4 py-2.5 rounded-lg font-bold text-sm shadow-sm hover:bg-[#0d3678] transition-all">
          Start New Review
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="card p-6 border-t-4 border-t-[#00AEEF]">
          <h3 className="text-gray-500 text-xs font-bold uppercase tracking-wider mb-2">Company Average</h3>
          <p className="text-4xl font-bold text-gray-800 mb-2">4.2 <span className="text-lg text-gray-400 font-medium">/ 5.0</span></p>
          <p className="text-sm text-green-600 font-medium flex items-center gap-1"><SafeIcon name="TrendingUp" size={16} /> +0.3 from last cycle</p>
        </div>
        <div className="card p-6 border-t-4 border-t-yellow-400">
          <h3 className="text-gray-500 text-xs font-bold uppercase tracking-wider mb-2">Pending Reviews</h3>
          <p className="text-4xl font-bold text-gray-800 mb-2">14</p>
          <p className="text-sm text-gray-500 font-medium">Due by end of month</p>
        </div>
        <div className="card p-6 border-t-4 border-t-purple-500">
          <h3 className="text-gray-500 text-xs font-bold uppercase tracking-wider mb-2">Top Performers</h3>
          <p className="text-4xl font-bold text-gray-800 mb-2">28%</p>
          <p className="text-sm text-gray-500 font-medium">Scored above 4.5</p>
        </div>
      </div>

      <div className="card border border-gray-100 overflow-hidden shadow-sm">
        <div className="p-4 bg-gray-50 border-b border-gray-100 flex justify-between items-center">
          <h3 className="font-bold text-gray-700">Recent Appraisals</h3>
          <button className="text-[#11469A] text-sm font-bold hover:underline">View All</button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm whitespace-nowrap">
            <thead className="bg-white text-gray-400 font-bold uppercase text-[10px] tracking-widest border-b border-gray-100">
              <tr>
                <th className="px-6 py-4">Employee</th>
                <th className="px-6 py-4">Department</th>
                <th className="px-6 py-4">Rating</th>
                <th className="px-6 py-4">Cycle</th>
                <th className="px-6 py-4">Status</th>
                <th className="px-6 py-4 text-right">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50 bg-white">
              {REVIEWS.map(rev => (
                <tr key={rev.id} className="hover:bg-gray-50/50">
                  <td className="px-6 py-4 font-bold text-gray-800">{rev.name}</td>
                  <td className="px-6 py-4 text-gray-600">{rev.dept}</td>
                  <td className="px-6 py-4 font-bold text-[#11469A]">{rev.score}</td>
                  <td className="px-6 py-4 text-gray-500">{rev.date}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider ${
                      rev.status === 'Completed' ? 'bg-green-50 text-green-600' : 'bg-yellow-50 text-yellow-600'
                    }`}>
                      {rev.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <button className="text-[#00AEEF] hover:text-[#11469A] font-bold text-xs uppercase tracking-wider">View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Performance;